



















































import { Component, Vue, Prop } from 'vue-property-decorator';
import UserStore, { UserStoreInterface } from '@/resource/user/user.store';
import { validateEmail, validateNotEmpty } from '@/utils/form-validation';
import BeatLoader from 'vue-spinner/src/BeatLoader.vue';

@Component({
  components: {
    BeatLoader,
  },
})
export default class Signin extends Vue {
  @Prop({ default: false })
  stayOnSamePage: boolean;

  @Prop({ default: false })
  hideSignup: boolean;

  userStore: UserStoreInterface = UserStore;

  isLoading = false;

  emailInput = '';
  emailError: string | boolean = false;

  passwordInput = '';
  passwordError: string | boolean = false;

  get redirectTo(): string {
    if (typeof this.$route.query.redirect === 'string') {
      return this.$route.query.redirect.trim();
    } else {
      return '';
    }
  }

  async signinSubmitted() {
    if (this.isLoading) return;
    this.isLoading = true;

    let hasError = false;

    if (!validateEmail(this.emailInput)) {
      this.emailError = 'Not valid email';
      hasError = true;
    } else {
      this.emailError = false;
    }

    if (!validateNotEmpty(this.passwordInput)) {
      this.passwordError = 'Password cannot empty';
      hasError = true;
    } else {
      this.passwordError = false;
    }

    if (hasError) {
      this.isLoading = false;
      return;
    }

    await this.userStore.signin({
      email: this.emailInput,
      password: this.passwordInput,
    });

    if (this.userStore.error) {
      this.emailError = 'Email not match';
      this.passwordError = 'Password not match';
      this.isLoading = false;

      this.$sendMpEvent({
        event: this.$mp_value.ErrorSignin,
        properties: {
          error: this.userStore.error.message,
          email: this.emailInput,
        },
      });

      return;
    } else {
      this.$sendMpEvent({ event: this.$mp_value.SignIn });

      this.redirectUser();
    }
  }

  redirectUser() {
    if (this.stayOnSamePage) {
      this.$router.go(0);
    } else if (this.$router.currentRoute.name === 'subjects') {
      this.$router.go(0);
    } else if (this.redirectTo) {
      this.$router.push({
        path: this.redirectTo,
      });
    } else {
      this.$router.push({
        name: 'browse',
      });
    }
  }

  signupClick() {
    this.$router.push({
      path: '/signup',
    });
  }

  forgotPasswordClick() {
    this.$router.push({
      path: '/amnesia',
    });
  }
}
